module.exports = __webpack_public_path__ + "media/images/area/feature/chubu/related/vi/4-d8659ab258a234996b91f15cc4a15be2.jpg";